/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : ADDONS PAGE : STYLES --------------- ++++++++++ */
export default theme => ({
    addons: {
        '& strong': {
            fontWeight: 'bold'
        },
        '& .codepiece': {
            '& p.description': {
                color: 'rgb(22, 51, 124)'
            },
            '& .group': {
                '& .field': {
                    '& .formelement': {
                        height: '48px'
                    },
                    '& input.textfield': {
                        height: '48px',
                        fontSize: pxToEm(14)
                    }
                }
            }
        },
        '& .sectiongroup': {
            '& .inlinemessage': {
                marginTop: pxToEm(20),
                fontWeight: 'normal',
                '& .message-icon': {
                    color: 'rgb(152, 167, 198)',
                    alignSelf: 'flex-start',
                    marginTop: pxToEm(2)
                }
            }
        },
        '& .collapsable': {
            overflow: 'hidden',
            '&.opened': {
                overflow: 'visible'
            }
        }
    }
});
